document.addEventListener('DOMContentLoaded', () => {
  class YGAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const header = this.querySelector(".yg-accordion-header");
      const content = this.querySelector(".yg-accordion-content");
      const trueHeight = content.scrollHeight;
      content.style.setProperty("--true-height", `${trueHeight}px`);
      header.addEventListener("click", () => {
        this.classList.toggle("yg-accordion-open");
      });
    }
  }

  if (!window.customElements.get("yg-accordion")) {
    window.customElements.define("yg-accordion", YGAccordion);
  }
});
